import { defineStore } from 'pinia'

export const useViewStore = defineStore('view', {
  state: () => ({
    actionView: null,
	chartsActiveTab: 'comprg',
	username: '',
	currentCustomer: null,
	currentStandort: null,
	openProjects: [],
	allBookings: true,
	activeProjects: true,
	plannedProjects: false,
	resourceFilters: {},
	refreshKey: 0,
  }),
  actions: {
	forceRefresh() {
      this.refreshKey++
    },
    setActionView(view) {
	  console.log("setActionView=" + view)
      this.actionView = view
    },
	setUsername(username) {
	  this.username = username
	},
	setCurrentCustomer(currentCustomer) {
		this.currentCustomer = currentCustomer;
	},
	setCurrentStandort(currentStandort) {
		this.currentStandort = currentStandort;
	},
	geCurrentCustomer() {
	  return this.currentCustomer;
	},
	getCurrentStandort() {
	  return this.currentStandort;
	},
	isViewDesktop() {
		return this.actionView === 'desktop'
	},
	isViewRegistry() {
		return this.actionView.startsWith('registry');
	},
	setViewDesktop() {
		this.actionView = 'desktop';
	},
	setViewRegistry() {
		this.actionView = 'registry.dashboard';
	},
  },
  persist: true
})
